export class NotificationMessageModel {
    id: number;
    messageText: string;
    messageTitle: string;
    expirationDate: Date;
    redirectUrl: string;
    senderUserLoginId: number;
}
